(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup-consent"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const link = target.closest('[data-policy-dialog]');
    if (link instanceof HTMLElement) {
      const dialog = document.getElementById(link.dataset.policyDialog || '');
      if (dialog instanceof HTMLDialogElement) {
        event.preventDefault();
        dialog.showModal();
      }
      return;
    }

    // Close when the backdrop is clicked
    if (target instanceof HTMLDialogElement && target.classList.contains('email-consent__dialog')) {
      target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
